/**
 * Chrome del pannello filtri (estratto da FantAPP via mixin sul prototype).
 * Tutte le funzioni usano `this` (l'istanza FantAPP) esattamente come prima.
 */
import { eventManager, Events } from "../core/events.js";
import { filtersManager } from "../features/filters/index.js";

/**
 * Chrome pannello filtri: azzera, hint attivi, sync chip
 */
export function setupFiltersChrome() {
  const resetBtn = document.querySelector("[data-testid='filters-clear']");
  const searchClearBtn = document.querySelector("[data-testid='search-clear']");
  const searchInput = document.querySelector(".player-search");

  if (resetBtn && !resetBtn.dataset.bound) {
    resetBtn.dataset.bound = "1";
    resetBtn.addEventListener("click", () => {
      filtersManager.resetFilters();
      if (searchInput) searchInput.value = "";
      this.syncFilterChipStates();
      this.syncFiltersChrome();
    });
  }

  if (searchClearBtn && searchInput && !searchClearBtn.dataset.bound) {
    searchClearBtn.dataset.bound = "1";
    searchClearBtn.addEventListener("click", () => {
      searchInput.value = "";
      filtersManager.setFilter("search", "");
      searchInput.focus();
      this.syncFiltersChrome();
    });
  }

  if (!this._filtersChromeEventsBound) {
    this._filtersChromeEventsBound = true;
    eventManager.on(Events.FILTERS_CHANGE, () => {
      this.syncFiltersChrome();
      this.syncHideStudioFilterChrome();
    });
    eventManager.on(Events.FILTERS_RESET, () => {
      if (searchInput) searchInput.value = "";
      this.syncFilterChipStates();
      this.syncFiltersChrome();
      this.syncShowExitedFilterChrome();
      this.syncHideStudioFilterChrome();
    });
    eventManager.on(Events.TABLE_UPDATE, () => this.syncFiltersChrome());
  }

  const showExitedBtn = document.querySelector("[data-testid='show-exited-toggle']");
  if (showExitedBtn && !showExitedBtn.dataset.bound) {
    showExitedBtn.dataset.bound = "1";
    showExitedBtn.addEventListener("click", () => {
      const next = !filtersManager.getFilter("showExited");
      filtersManager.setFilter("showExited", next);
      this.syncShowExitedFilterChrome();
    });
  }

  const hideStudioBtn = document.querySelector("[data-testid='hide-studio-toggle']");
  if (hideStudioBtn && !hideStudioBtn.dataset.bound) {
    hideStudioBtn.dataset.bound = "1";
    hideStudioBtn.addEventListener("click", () => {
      filtersManager.setListContext({
        studioTargets: this.state.studioTargets,
        studioDrafts: this.state.studioDrafts,
      });
      const next = !filtersManager.getFilter("hideStudio");
      filtersManager.setFilter("hideStudio", next);
      this.syncHideStudioFilterChrome();
    });
  }

  this.syncShowExitedFilterChrome();
  this.syncHideStudioFilterChrome();
  this.syncFiltersChrome();
}

export function countActiveFilters() {
  const { search, roles, showExited, hideStudio } = filtersManager.getFiltersState();
  let n = 0;
  if (search) n += 1;
  n += roles.length;
  if (showExited && this.state?.auctionMode === "live") n += 1;
  if (hideStudio) n += 1;
  return n;
}

export function syncFiltersChrome() {
  const resetBtn = document.querySelector("[data-testid='filters-clear']");
  const searchClearBtn = document.querySelector("[data-testid='search-clear']");
  const searchInput = document.querySelector(".player-search");
  const activeCount = this.countActiveFilters();
  const searchTerm = searchInput?.value?.trim() || "";

  if (searchClearBtn) {
    searchClearBtn.hidden = !searchTerm;
  }
  if (resetBtn) {
    resetBtn.hidden = activeCount === 0;
  }
}

export function syncFilterChipStates() {
  const { roles } = filtersManager.getFiltersState();
  document.querySelectorAll(".role-filter").forEach((btn) => {
    const role = btn.dataset.role;
    btn.classList.toggle("active", roles.includes(role));
    btn.setAttribute("aria-pressed", roles.includes(role) ? "true" : "false");
  });
}

/**
 * Sincronizza contesto filtri lista con modalità asta, roster e usciti asta; riapplica filtri.
 */
export function syncAuctionModeListFilters() {
  const mode = this.state.auctionMode === "live" ? "live" : "prep";
  filtersManager.setListContext({
    auctionMode: mode,
    auctionExits: this.state.auctionExits,
    roster: this.state.roster,
    studioTargets: this.state.studioTargets,
    studioDrafts: this.state.studioDrafts,
  });
  if (mode === "prep" && filtersManager.getFilter("showExited")) {
    filtersManager.setFilter("showExited", false);
  }
  this.syncShowExitedFilterChrome();
  this.syncHideStudioFilterChrome();
  filtersManager.applyFilters();
}

export function syncHideStudioFilterChrome() {
  const btn = document.querySelector("[data-testid='hide-studio-toggle']");
  if (!btn) return;
  const isLive = this.state?.auctionMode === "live";
  btn.hidden = isLive;
  if (isLive) return;
  const on = Boolean(filtersManager.getFilter("hideStudio"));
  btn.classList.toggle("active", on);
  btn.setAttribute("aria-pressed", on ? "true" : "false");
}

/** Aggiorna mappe Studio nel filtro lista e riapplica se serve. */
export function syncListaStudioFilterContext() {
  filtersManager.setListContext({
    studioTargets: this.state.studioTargets,
    studioDrafts: this.state.studioDrafts,
  });
  if (filtersManager.getFilter("hideStudio")) {
    filtersManager.applyFilters();
  }
}

export function syncShowExitedFilterChrome() {
  const btn = document.querySelector("[data-testid='show-exited-toggle']");
  const isLive = this.state?.auctionMode === "live";
  if (!btn) return;
  btn.hidden = !isLive;
  const on = Boolean(filtersManager.getFilter("showExited"));
  btn.classList.toggle("active", on);
  btn.setAttribute("aria-pressed", on ? "true" : "false");
}

/** @deprecated Nessun toggle legacy (assegnati/tag rimossi; usare Studio). */
export function setupToggleButtons() {}
